import { runInAction } from 'mobx';
import presizeBackendRest from '../../services/presize-backend-rest';
import { mapRestOrderToStoreOrder } from '../../lib/adapters/order-adapter';
import { SizingStore } from './sizing-store';
import { CgGroupingLevel, cgGroupingLevelToNumber } from '../../models/sizing-group';
import { sendSizingAppliedEventForGroups } from '../../lib/fragment-helper';
import { sendEvent } from '../../services/event-tracking';
import { isDbMigrated } from '../../lib/rest-feature-flag';

export class ChangeGroupingLevelAction {
  async changeGroupingLevel(this: SizingStore, level: CgGroupingLevel): Promise<void> {
    const { referenceId } = this;

    const response = await presizeBackendRest.updateOrder(referenceId, {
      cg_grouping_level: cgGroupingLevelToNumber(level),
    });
    const orderData = mapRestOrderToStoreOrder(response);
    runInAction(() => {
      this.groupingCgLevel = orderData.groupingLevel;
    });

    if (isDbMigrated()) {
      await this.regroupAndReloadSizing();
    } else {
      await this.groupArticles();
      sendSizingAppliedEventForGroups(this.sizingGroups);
    }

    this.sizingGroups.forEach((group) => {
      sendEvent(group, 'changeCGGrouping', undefined, this.additionalData());
    });
  }
}
